import { ConfirmDialog } from '@/components/confirm-dialog'
import { listTagsWithRelationsQuery } from '@/queries/tags.query'
import { TagService } from '@/services/tag.service'
import { useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { toast } from 'sonner'
import { useTags } from '../context/tags-context'
import { TagsMutateDrawer } from './tags-mutate-drawer'

export function TagsDialogs() {
  const { open, setOpen, currentRow, setCurrentRow } = useTags()
  const queryClient = useQueryClient()


  return (
    <>
      {open === 'create' && (
        <TagsMutateDrawer
          key='tag-create'
          open={open === 'create'}
          onOpenChange={() => setOpen('create')}
        />
      )}

      {currentRow && (
        <>
          <TagsMutateDrawer
            key={`tag-update-${currentRow.id}`}
            open={open === 'update'}
            onOpenChange={() => {
              setOpen('update')
              setTimeout(() => {
                setCurrentRow(null)
              }, 100)
            }}
            currentRow={currentRow}
          />

          <ConfirmDialog
            key='tag-delete'
            destructive
            open={open === 'delete'}
            onOpenChange={() => {
              setOpen('delete')
              setTimeout(() => {
                setCurrentRow(null)
              }, 100)
            }}
            handleConfirm={() => {
              setOpen(null)
              setTimeout(() => {
                setCurrentRow(null)
              }, 100)
              toast.promise(TagService.delete(currentRow.id), {
                loading: 'Excluindo segmento...',
                success: () => {
                  queryClient.invalidateQueries(listTagsWithRelationsQuery);
                  return 'Segmento excluído'
                },
                error: () => {
                  queryClient.invalidateQueries(listTagsWithRelationsQuery);
                  return 'Erro ao excluir segmento.'
                },
              })
            }}
            className='max-w-md'
            title={`Excluir este segmento: ${currentRow.name} ?`}
            desc={(
              <React.Fragment>
                Você está prestes a excluir o segmento {' '}
                <strong>{currentRow.name}</strong>. <br />
                Esta ação não pode ser revertida.
              </React.Fragment>
            )}
            confirmText='Excluir'
          />
        </>
      )}
    </>
  )
}
